<template>
  <div class="product-image" :class="{ border }">
    <div v-if="src">
      <div v-if="isString">
        <div v-if="aspectRatio" :style="`padding-top: ${aspectRatio*100}%`" />
        <img class="fill" :src="src" />
      </div>

      <div v-else-if="isArray">
        <v-carousel height="auto" hide-delimiter-background show-arrows-on-hover>
          <div v-for="(img, i) in src" :key="i">
            <v-carousel-item v-if="img.image_url" :src="img.image_url" />
          </div>
        </v-carousel>
      </div>

      <div v-else-if="isObject">
        <div v-if="aspectRatio" :style="`padding-top: ${aspectRatio*100}%`" />
        <img class="fill" :src="src.image_url" />
      </div>
    </div>
    <div v-else style="width: 100px; height: 100px">
      <v-icon class="fill">mdi-flower</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      type: Number,
      default: 0.666
    },
    src: {
      type: [String, Array, Object],
      default: ""
    }
  },

  computed: {
    isString() {
      return typeof this.src === "string";
    },
    isArray() {
      return Array.isArray(this.src);
    },
    isObject() {
      return typeof this.src === "object";
    }
  }
};
</script>

<style lang="scss" scoped>
.product-image {
  position: relative;
  overflow: hidden;

  &.border {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}

.fill {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
